import BzbsProfile from "@/core/Account/service/BzbsProfile";

export default function (states) {
    const loadUserProfile = function () {
        return new Promise((resolve, reject) => {
            BzbsProfile.getProfile(states.query.token, states.query.jwt).subscribe({
                next: (profile) => {
                    states.profile = profile
                    resolve(profile)
                },
                error: (err) => {
                    states.profile = null
                    reject(err)
                }
            })
        })
    }

    return {
        loadUserProfile
    }
}
